var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhosMyShopper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_782_20859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3381 79.7578H63.7818M36.6714 79.7578H37.1151",
    stroke: "currentColor",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1123 1.98439H11.4227C12.3134 1.98243 13.184 2.24853 13.9214 2.7481C14.6587 3.24766 15.2287 3.95756 15.5571 4.78545L32.2227 46.4281L26.5352 57.7625C26.1934 58.4424 26.0319 59.1987 26.066 59.9589C26.1002 60.7192 26.3289 61.4579 26.7303 62.1044C27.1317 62.751 27.6924 63.2836 28.3586 63.6515C29.0248 64.0193 29.7742 64.2099 30.5352 64.2052H72.2227",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7789 15.3203H81.1123L68.6685 46.4307H32.2227",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_782_20859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhosMyShopper);
export default __webpack_public_path__ + "static/media/whos-my-shopper.aaed87c0fb89b86c7e52b51209a0cced.svg";
export { ForwardRef as ReactComponent };